import { render, staticRenderFns } from "./AddOrUpdateOrganizational.vue?vue&type=template&id=0e106b98&scoped=true&"
import script from "./AddOrUpdateOrganizational.vue?vue&type=script&lang=js&"
export * from "./AddOrUpdateOrganizational.vue?vue&type=script&lang=js&"
import style0 from "./AddOrUpdateOrganizational.vue?vue&type=style&index=0&id=0e106b98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e106b98",
  null
  
)

export default component.exports